<div
  class="flex w-full flex-col gap-6 pt-6 text-primary-text lg:flex-row lg:gap-12 lg:pt-10"
>
  <!-- Image Section -->
  <div class="hidden items-start lg:block lg:w-1/3">
    <div class="max-w-sm min-w-80">
      <img
        class="h-auto bg-gray-300 object-cover"
        [src]="
          magazine().media?.cover?.url ?? '/assets/images/image-placeholder.png'
        "
        [alt]="imageAlt() | translate"
      />
    </div>
  </div>
  <!-- Details Section -->
  <div class="lg:max-w-6xl flex flex-grow flex-col gap-10 lg:w-2/3">
    <!-- Top Section: Titles and Buttons -->
    <div class="flex flex-col gap-6">
      <div class="flex flex-col">
        <h1
          class="relative w-full text-4xl leading-tight font-medium break-words lg:text-6xl lg:leading-tight"
        >
          {{ magazine().title }}
        </h1>
        @if (subtitle) {
          <div
            class="mt-2 w-full text-xl leading-tight font-medium break-words sm:text-2xl lg:text-3xl"
          >
            {{ subtitle }}
          </div>
        }
      </div>
      <!-- Buttons -->
      <div class="flex w-full flex-col gap-2 md:w-auto md:flex-row lg:gap-4">
        <ng-content select="[buttons]"></ng-content>
      </div>
    </div>
    <!-- Metadata Section -->
    <ng-content select="[metadata]"></ng-content>
    <!-- Editorial Board -->
    @if (edition) {
      <dhp-editorial-board
        [editionId]="edition.id"
        [magazine]="magazine()"
      ></dhp-editorial-board>
    }
  </div>
</div>
